import { init } from '@dash0/sdk-web';

import getEnvValue from 'commons/getEnvValue';
import { logError } from 'commons/logger';
import version from '../version.cjs.js';

const DASH0_ENDPOINT = getEnvValue('NEXT_PUBLIC_TRACING_DASH0_ENDPOINT');
const DASH0_AUTH_TOKEN = getEnvValue('NEXT_PUBLIC_TRACING_DASH0_AUTH_TOKEN');
const ENVIRONMENT_NAME = getEnvValue('NEXT_PUBLIC_ENV_NAME') ?? 'unknown';

// [^/?#]* restricts matching to the hostname only, preventing false positives
// when joybird.com appears in query parameters of third-party URLs.
const JOYBIRD_URL_REGEX = /^https:\/\/(?!(?:gtm|rudr))[^/?#]*\.joybird\.com/;

// Convert a URL string to a RegExp that matches URLs starting with that string,
// ensuring we only match at a URL boundary so we don't include unintended hosts
// like "https://api.joybird.com.evil/...".
// Returns undefined if the input is falsy (e.g. env var not set on client).
const urlToRegExp = url =>
  url
    ? new RegExp(`^${url.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}(?:[/?#]|$)`)
    : undefined;

const initDash0WebSdk = () => {
  try {
    // Dash0 propagator match arrays require RegExp objects, not strings.
    const graphqlBaseRegex = urlToRegExp(
      getEnvValue('NEXT_PUBLIC_GRAPHQL_BASE_URL')
    );
    const privateGraphqlRegex = urlToRegExp(
      process.env.PRIVATE_GRAPHQL_BASE_URL
    );

    init({
      serviceName: 'consumer',
      serviceVersion: version,
      endpoint: {
        url: DASH0_ENDPOINT,
        authToken: DASH0_AUTH_TOKEN,
      },
      environment: ENVIRONMENT_NAME,
      propagators: [
        // W3C traceparent headers for external Joybird APIs
        { type: 'traceparent', match: [JOYBIRD_URL_REGEX] },
        ...(graphqlBaseRegex
          ? [{ type: 'traceparent', match: [graphqlBaseRegex] }]
          : []),
        ...(privateGraphqlRegex
          ? [{ type: 'traceparent', match: [privateGraphqlRegex] }]
          : []),
        { type: 'traceparent', match: [/^https?:\/\/[^/?#]*\.local/] },
        { type: 'traceparent', match: [/^https?:\/\/localhost/] },
      ],
    });
  } catch (err) {
    logError(err, { message: 'Error initializing Dash0 Web SDK on client' });
  }
};

export default initDash0WebSdk;
